import mutations from "./mutations";
import queries from "./queries";

export default {
  queries,
  mutations,
};
